<template>
	<div>
		<div :class="getClass" v-if="(position.x || position.y) && nowData.length">
			<div class="list_item" v-for="(item, index) in nowData" :key="index" @click="handleClick(item)">
				<div class="item_name">{{ item.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		position: {
			type: Object,
			default: () => {
				return { x: 0, y: 0 };
			},
		},
		type: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		arrow: {
			type: String,
			default: 'right',
		},
	},
	data() {
		return {
			localData: [],
			password: 'assured',
		};
	},
	computed: {
		nowData() {
			if (this.type == 'idCard') {
				if (this.name) {
					return this.localData.filter(item => item.certificateType == '01' && item.name.indexOf(this.name) != -1);
				} else {
					return this.localData.filter(item => item.certificateType == '01');
				}
			} else if (this.type == 'passport') {
				if (this.name) {
					return this.localData.filter(item => item.certificateType != '01' && item.name.indexOf(this.name) != -1);
				} else {
					return this.localData.filter(item => item.certificateType != '01');
				}
			} else {
				return this.localData;
			}
		},

		getClass() {
			return this.arrow == 'left' ? 'last_box_left' : 'last_box_right';
		},
	},
	created() {
		this.localData = this.$base.getLocalData();
	},
	methods: {
		//提交成功后保存数据
		saveDataToLocal(assuredList) {
			this.$base.saveDataToLocal(assuredList);
		},

		handleClick(item) {
			this.$emit('selectAssured', item);
		},
	},
};
</script>

<style lang="scss" scoped>
.last_box_left {
	font-size: 0.26rem;
	width: 3rem;
	background-color: #fff;
	border-radius: 0.1rem;
	padding: 0.1rem 0;
	z-index: 10;
	box-shadow: 0rem 0.04rem 0.16rem 0rem rgba(0, 0, 0, 0.2);
	.list_item {
		padding: 0.1rem;
	}
	.item_name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		&:hover {
			background-color: #f5f5f5;
		}
	}

	&::after {
		content: '';
		position: absolute;
		top: -0.36rem;
		left: 0.2rem;
		transform: translate(-50% 0);
		border-width: 0.2rem;
		border-style: solid;
		border-color: transparent transparent #fff transparent;
		// 为箭头添加阴影
		filter: drop-shadow(0 -0.02rem 0.04rem rgba(0, 0, 0, 0.1));
	}
}
.last_box_right {
	font-size: 0.26rem;
	width: 3rem;
	background-color: #fff;
	border-radius: 0.1rem;
	padding: 0.1rem 0;
	z-index: 10;
	box-shadow: 0rem 0.04rem 0.16rem 0rem rgba(0, 0, 0, 0.2);
	.list_item {
		padding: 0.1rem;
	}
	.item_name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		&:hover {
			background-color: #f5f5f5;
		}
	}

	&::after {
		content: '';
		position: absolute;
		top: -0.36rem;
		right: 0.2rem;
		transform: translate(-50% 0);
		border-width: 0.2rem;
		border-style: solid;
		border-color: transparent transparent #fff transparent;
		// 为箭头添加阴影
		filter: drop-shadow(0 -0.02rem 0.04rem rgba(0, 0, 0, 0.1));
	}
}
</style>
